import { authorize, putRequest } from 'utils/http';
import { Environment } from 'global/environment';

export async function deactivateUserAPI(userId) {
  return putRequest(`${Environment.BACKEND_API}/admin/users/${userId}/deactivate`, {}, await authorize());
}
